import Footer24 from '@/components/organisms/Footer24';
import Header24 from '@/components/organisms/Header24';
import React, { useState } from 'react';
import Styles from './TabGroupCanaisAtendimento.css';
import CanaisAtendimentoConteudoBlog from '../CanaisAtendimentoConteudoBlog';
import BannerCanaisAtendimento from '../BannerCanaisAtendimento';
import CanaisAtendimentoServicos from '@/components/organisms/CanaisAtendimentoServicos/CanaisAtendimentoServicos';
import CanaisAtendimentoWhatsapp from '@/components/organisms/CanaisAtendimentoWhatsapp/CanaisAtendimentoWhatsapp';
import { CanaisAtendimentoTabs } from '@/data/misc/CanaisAtendimentoTabs';
import CanaisAtendimentoCustomTabs from '@/components/organisms/CanaisAtendimentoCustomTabs';
import ContainerHome24 from '@/components/atoms/ContainerHome24';
import CanaisAtendimentoAreaCliente from '@/components/organisms/CanaisAtendimentoAreaCliente';
import CanaisAtendimentoTelefone from '@/components/organisms/CanaisAtendimentoTelefone';
import Head from 'next/head';
import CanaisAtendimentoEmprestimos from '@/components/organisms/CanaisAtendimentoEmprestimos';

function TabGroupCanaisAtendimento({ tab }) {
  const [currentTab, setCurrentTab] = useState(tab);

  const handleTab = (id) => {
    setCurrentTab(id);
  };

  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }

  return (
    <>
      <Head>
        <title>Canais de Atendimento | Santander Financiamentos</title>
        <meta
          name="Description"
          content="Canais de Atendimento da Santander Financiamentos. Acesse a Área do Cliente ou fale conosco via WhatsApp e tire suas dúvidas com praticidade e segurança. "
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/canais-de-atendimento.html"
        />
        <meta name="robots" content="index, follow" class="jsx-6d6cd829ab494fc3" />
        <meta
          name="keywords"
          content="Canais de atendimento, WhatsApp Santander
          Financiamentos, Área do Cliente Santander Financiamentos, Contato via	 
          WhatsApp, Contato Santander Financiamentos, Atendimento Santander	 	
          Financiamentos, Suporte Santander Financiamentos, Fale Conosco Santander, 
          Central de Atendimento Santander Financiamentos, Telefone Santander 
          Financiamentos, Suporte online Santander Financiamentos, Chat Santander 
          Financiamentos, Ajuda Santander Financiamentos, Serviços online Santander 
          Financiamentos, Acesso rápido Santander Financiamentos, Assistência Santander 
          Financiamentos, Dúvidas Santander Financiamentos, Contato rápido Santander Financiamentos, Atendimento digital Santander Financiamentos, Canais de atendimento santander financiamento"
        />

        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Canais de Atendimento | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/canais-de-atendimento.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="Canais de Atendimento da Santander Financiamentos. Acesse a Área do Cliente ou fale conosco via WhatsApp e tire suas dúvidas com praticidade e segurança. "
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/canais-de-atendimento/hero/banner-1440.webp"
        />
        <meta
          property="og:image:alt"
          content="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
        />
        <meta property="og:image:type" content="image/webp" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="627" />
        <meta property="og:type" content="website" />

        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="" />
        <meta name="twitter:title" content="Canais de Atendimento | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="Canais de Atendimento da Santander Financiamentos. Acesse a Área do Cliente ou fale conosco via WhatsApp e tire suas dúvidas com praticidade e segurança. "
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/canais-de-atendimento.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/assets/canais-de-atendimento/hero/banner-1440.webp"
        />
        <meta
          property="twitter:image:alt"
          content="Mulher branca pesquisando no celular sobre os canais de atendimento do Santander."
        />
        <meta property="twitter:image:type" content="image/webp" />
        <meta property="twitter:image:width" content="1200" />
        <meta property="twitter:image:height" content="627" />
      </Head>
      <Header24 />
      <BannerCanaisAtendimento />
      <CanaisAtendimentoServicos />

      <div className="bg-santander-symbol">
        <div className="bg-gray content-qrcode">
          <ContainerHome24>
            <h3 className="canais-atendimento-qrcode-title">Nossos canais digitais</h3>
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 992 && (
                  <p className="canais-atendimento-qrcode-paragrafo">
                    Você consegue fazer tudo o que faria em uma agência Santander
                  </p>
                )}
                {width > 992 && (
                  <p className="canais-atendimento-qrcode-paragrafo">
                    Utilize nossos canais de atendimento e tenha acesso a diversas funcionalidades
                    de forma fácil e rápida.
                    <br />
                    Se você possui um empréstimo com a Santander Financiamentos, consulte nossos
                    telefones em nossa &quot;Central Empréstimos&quot;.
                  </p>
                )}
              </>
            )}

            <CanaisAtendimentoCustomTabs
              className="canais-atendimento-custom-tab"
              initialTab={tab}
              tabs={CanaisAtendimentoTabs}
              onTabChanged={handleTab}
            />
          </ContainerHome24>
        </div>

        <CanaisAtendimentoWhatsapp
          show={currentTab === CanaisAtendimentoTabs['whatsapp-santander'].id}
        />

        <CanaisAtendimentoAreaCliente
          show={currentTab === CanaisAtendimentoTabs['area-do-cliente'].id}
        />

        <CanaisAtendimentoTelefone
          show={currentTab === CanaisAtendimentoTabs['central-financiamentos'].id}
        />
        {/* <CanaisAtendimentoEmprestimos
          show={currentTab === CanaisAtendimentoTabs['central-emprestimos'].id}
        /> */}
        <img
          className="bg-santander-symbol-img"
          src="assets/canais-de-atendimento/santander-symbol-new.svg"
          alt="logo santander"
        />
      </div>
      <CanaisAtendimentoConteudoBlog />
      <Footer24 />
      <style jsx>{Styles}</style>
    </>
  );
}

export default TabGroupCanaisAtendimento;
